import React, { useEffect, useState, useMemo } from "react";
import { NavLink } from "react-router-dom";
import clsx from "clsx";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import useStyles from "../../styles/drawerStyle";
import NubisLogo from "../../assets/images/nubis_logo_new.svg";

import DrawerList from "./DrawerList";
import AppbarRightSection from "./AppbarRightSection";
import ReleaseVersionText from "./ReleaseVersionText";
import { getCompanyImage } from "@/apis/apiCollection";
import { useGlobalState } from "@/GlobalProvider";
import { getPlatformDomain } from "@/helpers/utils";

const ResponsiveDrawer = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [fixedOpen, setFixedOpen] = useState(true);
  const fecLink = useMemo(() => {
    return getPlatformDomain();
  }, []);
  const { currentCompanyId } = useGlobalState();

  // const [imgSrc, setImgSrc] = useState(NubisLogo);
  const [imgSrc, setImgSrc] = useState("");

  const handleDrawerToggle = () => {
    setFixedOpen(!fixedOpen);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleLinkClick = e => {
    e.preventDefault();
    window.location.href = fecLink;
  };

  useEffect(() => {
    const getCompanyImg = async () => {
      try {
        // setImgSrc(NubisLogo);
        const { company_image } = await getCompanyImage();
        if (company_image && company_image.length > 0) {
          setImgSrc(company_image);
        }
      } catch (error) {
        console.error("Error fetching company image:", error);
      }
    };
    getCompanyImg();
  }, [currentCompanyId]);

  return (
    <div className={classes.root}>
      <AppBar
        position="fixed"
        color="inherit"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open || fixedOpen
        })}
      >
        <Toolbar>
          <div className={classes.toolbar}>
            <IconButton
              aria-label="open drawer"
              onClick={handleDrawerToggle}
              edge="start"
              className={classes.menuButton}
            >
              <MenuIcon />
            </IconButton>
            <a
              href={fecLink}
              className={classes.goToFecLogoLink}
              onClick={handleLinkClick}
            >
              <ChevronLeftIcon />
              {/* <img src={FecLogo} alt="fec logo" /> */}
              <Typography>Platform</Typography>
            </a>
          </div>
          <AppbarRightSection />
        </Toolbar>
      </AppBar>
      <Drawer
        onMouseOver={handleDrawerOpen}
        onMouseLeave={handleDrawerClose}
        PaperProps={{ elevation: 10 }}
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open || fixedOpen,
          [classes.drawerClose]: !open && !fixedOpen
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open || fixedOpen,
            [classes.drawerClose]: !open && !fixedOpen
          })
        }}
      >
        <NavLink to="/dashboard">
          <div className={classes.siteLogoLink}>
            {imgSrc && (
              <img
                src={imgSrc}
                alt="logo"
                className={classes.siteLogoLink_img}
              />
            )}
            {/*<Typography*/}
            {/*  variant="caption"*/}
            {/*  color="secondary"*/}
            {/*  className={classes.siteLogoLink_text}*/}
            {/*>*/}
            {/*  Nubis*/}
            {/*  <ReleaseVersionText />*/}
            {/*</Typography>*/}
          </div>
        </NavLink>
        <Divider />
        <DrawerList isListExpanded={open || fixedOpen} />
        {!fixedOpen && <ReleaseVersionText rwd={true} />}
      </Drawer>
    </div>
  );
};

export default ResponsiveDrawer;
